import { createContext } from 'react';

const FrequentPassengersContext = createContext();

export default FrequentPassengersContext;
